<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/OnAir.mp4"></video>
      <p class="description pd-top-40">
        Saksikan kolaborasi dan penampilan spesial dari para idolamu di Malam Puncak MNC 32nd Anniversary Celebration.  
        Sabtu, 6 November 2021, 18.00 WIB, LIVE di RCTI
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Onair',
  data () {
    return {

    }
  },
  methods: {
    // movePage() {
    //   this.$router.push('/onair-concert')
    // }
  }
}
</script>
